import React from 'react';
import { cn } from '@/lib/utils';

interface BrandMarkProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  wordmarkClassName?: string;
  markOpacity?: number;
}

export function BrandMark({
  className = '',
  size = 'md',
  showWordmark = true,
  wordmarkClassName = '',
  markOpacity = 1,
}: BrandMarkProps) {
  const dimension = size === 'sm' ? 18 : size === 'lg' ? 28 : 22;

  return (
    <div className={cn('inline-flex items-center gap-2.5', className)} data-testid="brand-mark">
      <svg
        width={dimension}
        height={dimension}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 transition-transform duration-300 group-hover:scale-105"
        style={{ opacity: markOpacity }}
        aria-hidden="true"
        data-testid="brand-mark-svg"
      >
        {/* Hairline Elliptical Ring (Orbit) */}
        <ellipse
          cx="12"
          cy="12"
          rx="10"
          ry="6.5"
          transform="rotate(-25 12 12)"
          stroke="var(--line-strong)"
          strokeWidth="1"
          fill="none"
        />

        {/* Four-Point Sparkle Star (Celestial Gold) */}
        <path
          d="M12 2C12 7.5 7.5 12 2 12C7.5 12 12 16.5 12 22C12 16.5 16.5 12 22 12C16.5 12 12 7.5 12 2Z"
          fill="var(--gold)"
          className="drop-shadow-[0_1px_1px_rgba(0,0,0,0.15)]"
        />
      </svg>

      {showWordmark && (
        <span
          className={cn(
            'font-serif font-semibold text-[var(--foreground)] tracking-[-0.02em]',
            size === 'sm' ? 'text-base' : size === 'lg' ? 'text-2xl' : 'text-xl',
            wordmarkClassName
          )}
          data-testid="brand-wordmark"
        >
          AstroPredict
        </span>
      )}
    </div>
  );
}
